import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Stack from "@mui/material/Stack";

/**
 * A single review row: left-aligned label, right-aligned value.
 *
 * Deliberately its own module rather than an export of `PublishReviewModal`:
 * domain bindings build `config.publishReview.extraRows` out of these, so
 * co-locating them would mean any spec that stubs the modal also loses the
 * primitive its own domain config needs.
 */
export const ReviewRow = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    spacing={2}
  >
    <IgTypography variant="body2" color="text.secondary">
      {label}
    </IgTypography>
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ textAlign: "right" }}
    >
      {children}
    </Stack>
  </Stack>
);
